// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"5236f86a","732":"1f9fd847","977":"d349b264"}[chunkId] + ".chunk.js";
};